import { Alert } from './Alert'

/**
 * The "stated error state" design/33-client-conventions.md §33.6 requires: title + correlation
 * identifier, never a raw message or exception (§9.h B4). A thin, fixed-shape wrapper over
 * `Alert` (`danger` variant) so every unexpected-failure rendering in the app looks identical.
 */
export function ErrorAlert({ title, detail, correlationId }: { title: string; detail?: string; correlationId?: string }) {
  return (
    <Alert variant="danger">
      <b className="text-tx">{title}</b>
      {detail && <div>{detail}</div>}
      {correlationId && <div className="text-small">Correlation: {correlationId}</div>}
    </Alert>
  )
}
